// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"wj_a bhs_b"};